import { useAuth0 } from '@auth0/auth0-react';

import PrimaryNavDrawer from '@/components/shared/PrimaryNavDrawer';

const CallbackPage = () => {
  const { error } = useAuth0();

  if (error) {
    console.error('Auth0 Callback error', error);
    return <div>Error</div>;
  }

  return (
    <div className="page-layout">
      <PrimaryNavDrawer />
    </div>
  );
};

export default CallbackPage;
